import { Map } from "immutable";
import { STATE_STATUS, QUESTIONARE_ACTIONS } from "constants";

const INITIAL_STATE = new Map({
    data: null,
    answers: null,
    answerStatus: STATE_STATUS.UNFETCHED,
    status: STATE_STATUS.UNFETCHED
});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case QUESTIONARE_ACTIONS.FETCH_QUESTIONARE:
        return state.set("status", STATE_STATUS.FETCHING);
    case QUESTIONARE_ACTIONS.FETCHED_QUESTIONARE:
        return state
            .set("status", STATE_STATUS.FETCHED)
            .set("data", payload.data);
    case QUESTIONARE_ACTIONS.FAILED_FETCH_QUESTIONARE: {
        return state.set("status", STATE_STATUS.FETCH_FAILED);
    }
    case QUESTIONARE_ACTIONS.FETCH_ANSWERS_FOR_QUESTIONARE:
        return state.set("answerStatus", STATE_STATUS.FETCHING);
    case QUESTIONARE_ACTIONS.FETCHED_ANSWERS_FOR_QUESTIONARE:
        return state
            .set("answerStatus", STATE_STATUS.FETCHED)
            .set("answers", payload.data);
    case QUESTIONARE_ACTIONS.FAILED_FETCH_ANSWERS_FOR_QUESTIONARE:
        return state.set("answerStatus", STATE_STATUS.FETCH_FAILED);
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
